import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { SortimentDetailResponseDTO } from "~app/common/models/sortiment/SortimentDetailResponseDTO";
import { SortimentListRequestDTO } from "~app/common/models/sortiment/SortimentListRequestDTO";
import { SortimentSaveRequestDTO } from "~app/common/models/sortiment/SortimentSaveRequestDTO";
import { SortimentDTO } from "~app/common/models/common/SortimentDTO";
import { ApiClientService } from "~app/common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class SortimentService {
    private readonly apiClient = inject(ApiClientService);

    search(request: SortimentListRequestDTO): Observable<SortimentDTO[]> {
        return this.apiClient.post<SortimentListRequestDTO, SortimentDTO[]>("produkt/searchforsortiment", request, true);
    }

    save(request: SortimentSaveRequestDTO): Observable<SortimentDTO> {
        return this.apiClient.post<SortimentSaveRequestDTO, SortimentDTO>("produkt/savesortiment", request, true);
    }

    get(id: number): Observable<SortimentDetailResponseDTO> {
        return this.apiClient.get<SortimentDetailResponseDTO>(`produkt/getsortimentbyid/${id}`, true);
    }

    getSortimentText(kod: string): Observable<string> {
        return this.apiClient.get<string>(`produkt/getsortimenttext?kod=${kod}`, true);
    }

    getNewSortiment(): Observable<SortimentDetailResponseDTO> {
        return this.apiClient.get<SortimentDetailResponseDTO>("produkt/getnewsortiment", true);
    }

}
